import { render, staticRenderFns } from "./ModalAddWarehouseChannel.vue?vue&type=template&id=23dbb5cf&"
import script from "./ModalAddWarehouseChannel.vue?vue&type=script&lang=js&"
export * from "./ModalAddWarehouseChannel.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddWarehouseChannel.vue?vue&type=style&index=0&id=23dbb5cf&prod&lang=scss&module=true&"
import style1 from "./ModalAddWarehouseChannel.vue?vue&type=style&index=1&id=23dbb5cf&prod&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports